export const AUTO_COMPLETE_INIT = 'AUTO_COMPLETE_INIT';
export const AUTO_COMPLETE_REQUEST = 'AUTO_COMPLETE_REQUEST';
export const AUTO_COMPLETE_SUCCESS = 'AUTO_COMPLETE_SUCCESS';
export const AUTO_COMPLETE_FAILURE = 'AUTO_COMPLETE_FAILURE';
export const AUTO_COMPLETE_RESET = 'AUTO_COMPLETE_RESET';
export const AUTO_COMPLETE_DISABLED_CHANGE = 'AUTO_COMPLETE_DISABLED_CHANGE';
export const AUTO_COMPLETE_CONTROLLER_CHANGE =
  'AUTO_COMPLETE_CONTROLLER_CHANGE';
export const TRIGGERS = {
  INPUT_FOCUS: 'INPUT_FOCUS',
  INPUT_CHANGE: 'INPUT_CHANGE',
  ITEM_SELECT: 'ITEM_SELECT',
  INPUT_CLEAR: 'INPUT_CLEAR',
  COMPONENT_DID_MOUNT: 'COMPONENT_DID_MOUNT',
  RESET: 'RESET',
  CONTROLLER_CHANGED: 'CONTROLLER_CHANGED',
};



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/AutoComplete/AutoCompleteConstants.js